import { TouchPointHelper } from '../../../helpers/touchPointHelper';
import { placeholders, displayGroups } from '@ui';

export const subscriptionResumeAndAuthorization = {
	prismName: 'subscriptionResumeAndAuthorization',
	template: {
		templateName: 'subscriptionResumeAndAuthorizationTemplate',
		displayGroups: [
			TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [
				TouchPointHelper.createDisplayGroup(displayGroups.rowContainer, [
					TouchPointHelper.createDisplayGroup(
						displayGroups.leftPanel,
						[],
						[
							TouchPointHelper.createPlaceholder(placeholders.logo, {
								placeholderBuildReference: 10,
							}),
							TouchPointHelper.createPlaceholder(placeholders.wizardMenu, {
								placeholderBuildReference: 100,
							}),
							TouchPointHelper.createPlaceholder(placeholders.doubtsAndExit, {
								placeholderBuildReference: 200,
							}),
						]
					),
					TouchPointHelper.createDisplayGroup(
						displayGroups.columnContainer,
						[
							TouchPointHelper.createDisplayGroup(
								displayGroups.bodyPanel,
								[],
								[
									TouchPointHelper.createPlaceholder(placeholders.titleResumeAndAuthorization, {
										placeholderBuildReference: 10,
									}),
									TouchPointHelper.createPlaceholder(placeholders.costSummary, {
										placeholderBuildReference: 20,
									}),
									TouchPointHelper.createPlaceholder(placeholders.accountSelected, {
										placeholderBuildReference: 30,
									}),
									TouchPointHelper.createPlaceholder(placeholders.cloudwareDocument, {
										placeholderBuildReference: 40,
									}),
									TouchPointHelper.createPlaceholder(placeholders.bankDocument, {
										placeholderBuildReference: 50,
									}),
									TouchPointHelper.createPlaceholder(placeholders.changeEmail, {
										placeholderBuildReference: 60,
									}),
									TouchPointHelper.createPlaceholder(placeholders.availableAccountList, {
										placeholderBuildReference: 70,
									}),
								]
							),
						],
						[
							TouchPointHelper.createPlaceholder(placeholders.authenticatorFooter, {
								placeholderBuildReference: 1000,
							}),
							TouchPointHelper.createPlaceholder(placeholders.modals, {
								placeholderBuildReference: 1010,
							}),
						]
					),
				]),
			]),
		],
	},
};
